import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import "dayjs/locale/en";
import "dayjs/locale/en-gb";
import "dayjs/locale/ja";

dayjs.extend(updateLocale);

// Ensure all supported locales use Monday as the first day of the week
dayjs.updateLocale("en", { weekStart: 1 });
dayjs.updateLocale("en-gb", { weekStart: 1 });
dayjs.updateLocale("ja", { weekStart: 1 });

export default dayjs;
